module.exports = __webpack_public_path__ + "images/img-rkS3PxO.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/everad/assets/img/global/default-avatars/web_300x300.png
// module id = 987
// module chunks = 0